import Vue from 'vue'
import Loading from '../components/modal/LoadingShow.vue'
function RegisterComponent () {
  const parentEl = document.body
  let MyComponent = Vue.extend(Loading)
  let instance = new MyComponent().$mount()
  parentEl.appendChild(instance.$el)
  return instance
}
export default {
  install (Vue) {
    Vue.prototype.$showLoading = RegisterComponent()
  }
}
